import type { ApiProduct } from '../../../../../models/ecommerce/product/ApiProduct';
import { useRecipeProductSubstitutionContext } from '../../../../ecommerce/contexts/RecipeProductSubstitutionContext';
import type { RecipeItemState } from '../../../../recipe/models';
import DialogNavBack from '../../atoms/DialogNavBack';
import { useFocusRestoreManager } from '../../FocusRestoreProvider';
import RecipeProductSubstitutes from '../../RecipeProductSubstitutes';

const BuyableRecipeCartSubstitutes = (props: {
    storeId: string;
    items: RecipeItemState[];
    isLoading: boolean;
    onSubstituteChangeClick: (item: RecipeItemState, product: ApiProduct) => void;
    onSubstituteProductSuccess: () => void;
}) => {
    const { focusLast } = useFocusRestoreManager();
    const { itemToSubstitute, setItemToSubstitute } = useRecipeProductSubstitutionContext();

    const refocus = () => {
        setTimeout(focusLast, 200);
    };

    const close = () => {
        setItemToSubstitute(undefined);
        refocus();
    };

    return (
        itemToSubstitute && (
            <RecipeProductSubstitutes
                navigationSlot={<DialogNavBack label="Tillbaka till varukorgen" onClick={close} />}
                items={props.items}
                substituteIdentifier={itemToSubstitute.stableId}
                onSubstituteChangeClick={props.onSubstituteChangeClick}
                onSubstituteProductSuccess={() => {
                    close();
                    props.onSubstituteProductSuccess();
                }}
                isLoading={props.isLoading}
            />
        )
    );
};

export default BuyableRecipeCartSubstitutes;
